export const createFormData = (values, user) => {
  const formData = new FormData()
  if (values.prefered_store_name)
    formData.append('prefered_store_name', values.prefered_store_name);

  if (user?.business_id)
    formData.append('store_business_id', user.business_id);

  if (values.store_type)
    formData.append('provider', values.store_type);

  if (values.store_name)
    formData.append('store_name', values.store_name);

  if (values.name_arabic)
    formData.append('store_name_arabic', values.name_arabic);

  if (values.store_description)
    formData.append('store_description', values.store_description);

  if (values.registration_number)
    formData.append('registration_number', values.registration_number);

  if (values.business_url)
    formData.append('business_url', values.business_url);

  if (values.maroof_link)
    formData.append('maroof_link', values.maroof_link);

  if (values.location)
    formData.append('location', values.location);

  if (values.vat_number)
    formData.append('vat_number', values.vat_number);

  if (values.logo)
  formData.append('logo', values.logo)
  if (values.registration_certificate) 
  formData.append('registration_certificate', values.registration_certificate)
  if (values.vat_certificate)
    formData.append('vat_certificate', values.vat_certificate)

  values.countries.forEach((country) => {
    formData.append('countries', country)
  })

  return formData
}
